import { useState, useEffect } from 'react';
import {hostUrl} from "../utils/url-manager";
import {read_cookie} from "sfcookies";

type IndustrySelectNodeType = {
    id: string,
    name: string
}

type CountrySelectNodeType = {
    id: string,
    name: string
}



type SubscriptionTierSelectNodeType = {
    id: string,
    name: string
}


type UseGetIndustriesProps = {
    loadedIndustries: IndustrySelectNodeType[],
    loadingIndustries: boolean
}

export const useGetIndustries: () => UseGetIndustriesProps = (): UseGetIndustriesProps => {
    const [loadedIndustries, setLoadedIndustries] = useState<IndustrySelectNodeType[]>([]);
    const [loadingIndustries, setLoadingIndustries] = useState<boolean>(true);

    if (loadedIndustries && loadedIndustries.length <= 0 && setLoadingIndustries) {
        const token: string = read_cookie('auth');
        const request = new Request(hostUrl + 'hq_api/industries?itemsPerPage=500', {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token,
                'hq': 'hq'
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            })
            .then( (data: any): void => {
                setLoadingIndustries(false)
                let responseData: IndustrySelectNodeType[] = [];
                if (Array.isArray(data['hydra:member'])) {
                    const industries: any[] = data['hydra:member'];
                    for (let i: number = 0; i < industries.length; i++ ) {
                        let industry: any = industries[i];
                        let tmp: { id: string, name: string } = {
                            id: String(industry['id']),
                            name: industry['name']
                        }
                        responseData.push(tmp);
                    }
                }
                setLoadedIndustries(responseData);
            })
            .catch( (error: Error): Promise<any> => {
                console.log(error);
                return Promise.reject();
            });
    }

    return { loadedIndustries, loadingIndustries }
}

type UseGetCountriesProps = {
    loadedCountries: CountrySelectNodeType[],
    loading: boolean
}

export const useGetCountries: () => UseGetCountriesProps = (): UseGetCountriesProps => {
    const [loadedCountries, setLoadedCountries] = useState<CountrySelectNodeType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const token: string = read_cookie('auth');
    if (loadedCountries && loadedCountries.length <= 0) {
        const request: Request = new Request(hostUrl + 'hq_api/countries?itemsPerPage=500', {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token,
                'hq': 'hq'
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            })
            .then( (data: any): void => {
                setLoading(false)
                let responseData: CountrySelectNodeType[] = [];
                if (Array.isArray(data['hydra:member'])) {
                    const countries = data['hydra:member'];
                    for (let i: number = 0; i < countries.length; i++ ) {
                        let country: any = countries[i];
                        let tmp: { id: string, name: string } = {
                            id: country['code'],
                            name: country['name']
                        }
                        responseData.push(tmp);
                    }
                }
                setLoadedCountries(responseData);
            })
            .catch( (error: Error): Promise<any> => {
                console.log(error);
                return Promise.reject();
            });
    }
    return { loadedCountries, loading }
}


type UseGetSubscriptionTiersProps = {
    loadedSubscriptionTiers: SubscriptionTierSelectNodeType[],
    loadingSubscriptionTiers: boolean
}

export const useGetSubscriptionTiers: () => UseGetSubscriptionTiersProps = (): UseGetSubscriptionTiersProps => {
    const [ loadedSubscriptionTiers, setLoadedSubscriptionTiers ] = useState<SubscriptionTierSelectNodeType[]>([])
    const [loadingSubscriptionTiers, setLoadingSubscriptionTiers] = useState<boolean>(true);

    if (loadedSubscriptionTiers && loadedSubscriptionTiers.length <= 0) {
        const token: string = read_cookie('auth');
        const request: Request = new Request(hostUrl + 'hq_api/settings?code=product_pricing_tiers', {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token,
                'hq': 'hq'
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            })
            .then( (data: any): void => {

                setLoadingSubscriptionTiers(false)
                let responseData: SubscriptionTierSelectNodeType[] = [];
                if (Array.isArray(data['hydra:member'])) {
                    const settings: any = data['hydra:member']
                    if (settings[0] !== undefined) {
                        let setting: any = settings[0];
                        const settingValue: any = JSON.parse(setting['value'])
                        for (let i: number = 0; i < settingValue.length; i++) {
                            const settingVal: any = settingValue[i]
                            let tmp: { id: string, name: string } = {
                                id: settingVal['key'],
                                name: settingVal['value']
                            }
                            responseData.push(tmp);
                        }
                    }
                    // console.log(responseData);
                }
                setLoadedSubscriptionTiers(responseData);
            })
            .catch( (error: Error): Promise<any> => {
                console.log(error);
                return Promise.reject();
            });
    }
    return { loadedSubscriptionTiers, loadingSubscriptionTiers }
}

type UseStripeModeFetchProps = {
    isTestMode: boolean,
    loadingTestModeData: boolean
}

export const useStripeModeFetch: () => UseStripeModeFetchProps = (): UseStripeModeFetchProps => {
    const [isTestMode, setIsTestMode] = useState<boolean>(false);
    const [loadingTestModeData, setLoadingTestModeData] = useState<boolean>(true);

    const token: string = read_cookie('auth');
    const request: Request = new Request(hostUrl + 'hq_api/settings?code=stripe_test_mode_enabled', {
        method: 'GET',
        headers: new Headers({
            'Content-Type' : 'application/json',
            'token': token,
            'hq': 'hq'
        })
    });
    fetch(request)
        .then( (response: Response): Promise<any> => {
            return response.json()
        })
        .then( (data: any): void => {
            setLoadingTestModeData(false)
            if (Array.isArray(data['hydra:member'])) {
                const settings: any = data['hydra:member']
                if (settings[0] !== undefined) {
                    let setting: any = settings[0];
                    const settingValue: string = setting['value']
                    if (settingValue === 'true') {
                        setIsTestMode(true)
                    }
                }
            }
        })
        .catch( (error: Error): Promise<any> => {
            console.log(error);
            return Promise.reject();
        });
    return { isTestMode, loadingTestModeData }
}

type UseASettingByCodeProps = {
    loadingSetting: boolean,
    settingValue: string,
    error: string,
    loadSettingValue: any
}

export const useASettingByCode: (settingCode: string) => UseASettingByCodeProps = (settingCode: string): UseASettingByCodeProps => {
    const [loadingSetting, setLoadingSetting] = useState<boolean>(true);
    const [settingValue, setSettingValue] = useState<string>();
    const [error, setError] = useState<string>('');

    function loadSettingValue(settingCode: string ): void {
        const token: string = read_cookie('auth');
        const request: Request = new Request(hostUrl + 'hq_api/settings?code=' + settingCode, {
            method: 'GET',
            headers: new Headers({
                'Content-Type' : 'application/json',
                'token': token,
                'hq': 'hq'
            })
        });
        fetch(request)
            .then( (response: Response): Promise<any> => {
                return response.json()
            })
            .then( (data: any): void => {
                setLoadingSetting(false)
                if (Array.isArray(data['hydra:member'])) {
                    const settings: any = data['hydra:member']
                    if (settings[0] !== undefined) {
                        let setting: any = settings[0];
                        const settingVal: string = setting['value']
                        setSettingValue(settingVal);
                    } else {
                        setError('Setting Not Found!')
                    }
                }
            })
            .catch( (error: Error): Promise<any> => {
                console.log(error);
                return Promise.reject();
            });
    }

    useEffect( (): void => {
        if (window !== undefined && loadingSetting && (settingValue === undefined || settingValue === null || settingValue === "" ) && setLoadingSetting !== undefined) {
            loadSettingValue(settingCode);
        }
    }, [] );

    return { loadingSetting, settingValue, error, loadSettingValue }
}